import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { zText } from '../primitives';

export const docketTemplateSchema = z.object({
  categoryUuids: z.array(z.string()).default([]),
  name: z.string(),
  topMarginLines: z.number().default(0),
  uuid: z.string().default(() => uuidv4()),

  createdAt: z.number().optional(),
  updatedAt: z.number().optional(),
});
export type DocketTemplate = z.output<typeof docketTemplateSchema>;

export const docketTemplateStrictSchema = docketTemplateSchema.safeExtend({
  categoryUuids: z.array(z.guid()),
  name: zText,
  topMarginLines: z.number().nonnegative(),
  uuid: z.guid(),
});

export const docketTemplateCvxSchema = docketTemplateSchema.safeExtend({
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type DocketTemplateCvx = z.output<typeof docketTemplateCvxSchema>;
